module.exports = __webpack_public_path__ + "img/loud_viewer_3.c5afad4a.png";